import Human2 from "assets/images/pages/onboarding/human-2.webp";
import HumanImage from "assets/images/pages/onboarding/image-human.webp";
import Lets from "assets/images/pages/onboarding/lets.webp";
import { AuthContext } from "context/Auth";
import useLayoutConfig from "hooks/useLayoutConfig";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const InternshipOnboarding = () => {
  const [currentStep, setCurrentStep] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [isStepComplete, setIsStepComplete] = useState(false);
  const [showError, setShowError] = useState(false);
  useLayoutConfig("red", false);
  const { profile, setProfile } = useContext(AuthContext);

  let navigate = useNavigate();

  useEffect(() => {
    switch (currentStep) {
      case 3:
      case 4:
        setIsStepComplete(false);
        break;
      default:
        setIsStepComplete(true);
    }
  }, [currentStep]);

  const handleNext = () => {
    setShowError(false);
    if (currentStep === steps.length - 1) return;
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (currentStep === 0) return;
    setCurrentStep((prev) => prev - 1);
  };

  // use effect to check if profile has been welcomed before or not. if not, navigate to welcome component
  useEffect(() => {
    if (profile && profile.welcomed) {
      // react router navigate
      navigate("/user/dashboard");
    }
  }, []);

  // eslint-disable-next-line no-unused-vars
  const handleSubmit = async () => {
    setIsLoading(true);
    let setFormData = new FormData();
    setProfile({
      ...profile,
      onboarded: true,
      onboardedOn: new Date(),
    });

    setFormData.append(
      "createdOn",
      `${new Date().toDateString()} ${new Date().toLocaleTimeString()}`,
    );

    await fetch(
      "https://script.google.com/macros/s/AKfycbz-zR7WFnC_cFv1e5Ls_QQOTVhzIz_xWYeuRK1EaSA0EgAXbC4Emi4hAZ7AIsXzonsI/exec",
      {
        method: "POST",
        body: setFormData,
      },
    );

    setIsLoading(false);
  };

  const steps = [
    // 0
    {
      body: (
        <div className="text-center px-10">
          <h3 className="text-[20px] mt-">
            This is an opportunity to support quality education, social
            emotional learning & mental well-being of over
            <span className="font-bold"> 1500 underprivileged children </span>
            Plus, master the
            <span className="font-bold text-[20px]"> Art of Expression- </span>
            to learn a 21st-Century must-have skill & become the voice of our
            cause
          </h3>

          <button
            onClick={handleNext}
            className="bg-primary text-white rounded-[13px] px-5 py-2 mt-5 font-bold text-[18px] z-10 relative"
          >
            I Am In
          </button>
          <div className="absolute bottom-0 left-0 px-10 w-full justify-center flex">
            <img alt="HumanImage" src={HumanImage} height={250} width={350} />
          </div>
        </div>
      ),
    },
    // 1
    {
      body: (
        <div className="text-center px-10">
          <h3 className="text-[20px] mt-5">
            We need to{" "}
            <span className="font-bold">future-proof the next generation,</span>{" "}
            today by working on three key aspects of child development
          </h3>
          <ul className="font-bold text-[20px] list-none mt-5">
            <li>● &nbsp;Social Emotional Learning</li>
            <li>● &nbsp;Academic Support </li>
            <li>● &nbsp;Mental Well-Being</li>
          </ul>

          <button
            onClick={handleNext}
            className="bg-primary text-white rounded-[13px] px-5 py-2 mt-5 font-bold text-[18px] z-10 relative"
          >
            Boy, That’s Deep!
          </button>
          <div className="absolute bottom-0 left-0 px-10 w-full justify-center flex">
            <img alt="Human2" src={Human2} height={250} width={350} />
          </div>
        </div>
      ),
    },
    // 2
    {
      body: (
        <div className="text-center text-xl px-10">
          <h3>
            <strong>Be the face of Muskurahat.</strong>
            <br />
            Represent our cause with enthusiasm, sincerity, and professionalism.
          </h3>

          <h3>
            If you’re not ready to give it your best shot, no hard feelings—but
            this might not be for you.
          </h3>

          <button
            onClick={handleNext}
            className="bg-primary text-white rounded-[13px] px-5 py-2 mt-5 font-bold text-[18px] z-10 relative"
          >
            I Am Ready
          </button>
          <div className="absolute bottom-0 left-0 px-10 w-full justify-center flex">
            <img alt="Human2" src={Human2} height={250} width={350} />
          </div>
        </div>
      ),
    },
    // 3
    {
      body: (
        <div className="text-center text-xl px-10">
          <h3 className="mt-5">
            During this internship, you will be required to reach out to your
            personal network, tell them about the cause and raise funds. *
          </h3>
          <div className="flex flex-col w-3/4 m-auto">
            <label
              className="flex items-center justify-start mt-5 bg-[#E31D130D] has-[:checked]:bg-primary border border-primary rounded-[7px] px-5 py-4 text-primary has-[:checked]:text-white z-10 relative"
              htmlFor="personal-network-accept"
            >
              <span className="bg-[#E31D131A] border border-[#E31D1333] has-[:checked]:border-white p-3 mr-4 rounded-full h-10 w-10 flex justify-center items-center">
                a
                <input
                  type="radio"
                  onClick={handleNext}
                  id="personal-network-accept"
                  name="personal-network"
                  hidden
                />
              </span>{" "}
              I accept
            </label>

            <label
              className="flex items-center justify-start mt-5 bg-[#E31D130D] has-[:checked]:bg-primary border border-primary rounded-[7px] px-5 py-4 text-primary has-[:checked]:text-white z-10 relative"
              htmlFor="personal-network-reject"
            >
              <span className="bg-[#E31D131A] border border-[#E31D1333] has-[:checked]:border-white p-3 mr-4 rounded-full h-10 w-10 flex justify-center items-center">
                b
                <input
                  type="radio"
                  onClick={() => setShowError(true)}
                  id="personal-network-reject"
                  name="personal-network"
                  hidden
                />
              </span>
              I don&apos;t accept
            </label>
            {showError && (
              <p className="mt-5 text-primary animate-shake">
                Error: You can only proceed by Accepting The Requirements Of The
                Internship
              </p>
            )}
          </div>
          <div className="absolute bottom-0 left-0 px-10 w-full justify-center flex">
            <img alt="Human2" src={Human2} height={250} width={350} />
          </div>
        </div>
      ),
    },
    // 4
    {
      body: (
        <div className="text-center px-10 text-xl">
          <h3 className="mt-5">
            Would you like to sign up for this internship? *
          </h3>
          <div className="flex flex-col w-3/4 m-auto">
            <label
              className="flex items-center justify-start mt-5 bg-[#E31D130D] has-[:checked]:bg-primary border border-primary rounded-[7px] px-5 py-4 text-primary has-[:checked]:text-white z-10 relative"
              htmlFor="yes"
            >
              <span className="bg-[#E31D131A] border border-[#E31D1333] has-[:checked]:border-white p-3 mr-4 rounded-full h-10 w-10 flex justify-center items-center">
                a
                <input
                  type="radio"
                  onClick={handleNext}
                  id="yes"
                  name="signup"
                  hidden
                />
              </span>{" "}
              Yes
            </label>

            <label
              className="flex items-center justify-start mt-5 bg-[#E31D130D] has-[:checked]:bg-primary border border-primary rounded-[7px] px-5 py-4 text-primary has-[:checked]:text-white z-10 relative"
              htmlFor="no"
            >
              <span className="bg-[#E31D131A] border border-[#E31D1333] has-[:checked]:border-white p-3 mr-4 rounded-full h-10 w-10 flex justify-center items-center">
                b
                <input
                  type="radio"
                  onClick={() => setShowError(true)}
                  id="no"
                  name="signup"
                  hidden
                />
              </span>
              No
            </label>

            {showError && (
              <p className="mt-5 text-primary animate-shake">
                Error: You can only proceed by Accepting The Requirements Of The
                Internship
              </p>
            )}
          </div>
          <div className="absolute bottom-0 left-0 px-10 w-full justify-center flex">
            <img alt="Human2" src={Human2} height={250} width={350} />
          </div>
        </div>
      ),
    },
    // 5
    {
      body: (
        <div className="text-center px-10">
          <button
            disabled={!isStepComplete || isLoading}
            onClick={async () => {
              await handleSubmit();
              navigate("/user/dashboard");
            }}
            className="bg-primary text-white rounded-[13px] px-5 py-2 mt-5 font-bold text-[18px] z-10 relative"
          >
            {isLoading ? (
              // loading icon
              <svg
                className="animate-spin h-8 w-8"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V4a10 10 0 00-1.93 2.4"
                ></path>
              </svg>
            ) : (
              "Letss GO!!"
            )}
          </button>

          <div className="absolute bottom-0 left-0 px-10 w-full justify-center flex">
            <img alt="Lets" src={Lets} height={250} width={350} />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="h-[100dvh]">
      <div
        className={`h-dvh h-full bg-[url('assets/images/pages/onboarding/background.webp')] bg-cover overflow-x-hidden relative`}
      >
        <div
          style={{
            width: steps.length * 100 + "%",
            // width: "100%",
            transform: `translateX(-${currentStep * (100 / steps.length)}%)`,
          }}
          className={`h-full flex justify-center items-center h-dvh transition-transform duration-500 ease-in-out`}
        >
          {steps.map((step, index) => (
            <div
              key={index}
              className="w-screen h-full flex justify-center items-center relative"
            >
              {step.body}
            </div>
          ))}
        </div>
        <div className="absolute bottom-5 right-5 flex gap-1 z-10">
          <button
            className="bg-primary disabled:bg-grey disabled:cursor-not-allowed disabled:opacity-50"
            onClick={handlePrev}
            disabled={currentStep === 0 || currentStep === 19}
          >
            <svg
              stroke="currentColor"
              strokeWidth="0"
              viewBox="0 0 20 20"
              height="1.4em"
              width="1.4em"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>

          <button
            className="bg-primary disabled:bg-grey disabled:cursor-not-allowed disabled:opacity-50"
            onClick={handleNext}
            disabled={!isStepComplete || steps.length - 1 === currentStep}
          >
            {/* up arrow svg */}
            <svg
              stroke="currentColor"
              strokeWidth="0"
              viewBox="0 0 20 20"
              height="1.4em"
              width="1.4em"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InternshipOnboarding;
